import React, { CSSProperties } from "react";
import { ReactSVG } from "react-svg";
import { QRType } from "@/types/qr";
import { Wrapper } from "../Wrapper";
import { PreviewBrowser } from "../PreviewBrowser";

import "./styles.scss";

export default function PreviewLayout({
  children,
  page,
  backgroundColor,
  dataQA,
  includeBrowser,
  isInitPreview,
  containerStyle,
}: {
  children: any;
  page: QRType;
  backgroundColor?: string;
  dataQA?: string;
  includeBrowser?: boolean;
  isInitPreview?: boolean;
  containerStyle?: CSSProperties;
}) {
  return (
    <>
      <div
        className={`Preview-layout Preview-layout--${page}`}
        style={{
          backgroundColor: backgroundColor,
        }}
        data-qa={dataQA}
      >
        <div
          className={`Preview-layout__container`}
          style={containerStyle}
        >
          <Wrapper
            xs
            customClass="Preview-layout__wrapper"
          >
            {includeBrowser && <PreviewBrowser type={page} />}
            <div
              className={`layout-content ${
                includeBrowser ? "showBrowser" : ""
              } ${isInitPreview ? page + " initPreview" : ""}`}
            >
              {children}
            </div>
          </Wrapper>
        </div>
      </div>
      <ReactSVG
        src={`/images/phone-previews/phone-empty.svg`}
        className="preview-frame"
      />
    </>
  );
}
